import { CustomAttributeInputComponent } from '@accredible-frontend-v2/forms/custom-attribute-input';
import {
  CustomAttribute,
  CustomAttributeType,
  CustomAttributeValue,
} from '@accredible-frontend-v2/models';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { FilterService } from '../../../../services/filter.service';
import {
  SpotlightProfilesState,
  SpotlightProfilesStateAction,
} from '../../../../store/spotlight-profiles/spotlight-profiles.reducer';
import { selectSpotlightProfilesStateAction } from '../../../../store/spotlight-profiles/spotlight-profiles.selectors';

@UntilDestroy()
@Component({
  selector: 'sl-custom-attribute-filters',
  templateUrl: './custom-attribute-filters.component.html',
  styleUrls: ['./custom-attribute-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomAttributeFiltersComponent implements OnInit {
  @ViewChildren(CustomAttributeInputComponent)
  customAttributeInputs: QueryList<CustomAttributeInputComponent>;

  @Input()
  customAttributeFilters: CustomAttribute[];

  readonly customAttributeType = CustomAttributeType;
  readonly maxSelectAnyOptions = 6;

  private _spotlightProfileActions$ = this._spotlightProfileStore.select(
    selectSpotlightProfilesStateAction,
  );

  constructor(
    private readonly _spotlightProfileStore: Store<SpotlightProfilesState>,
    private readonly _filter: FilterService,
    private readonly _cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this._setupFilterResetTracking();
  }

  handleCustomAttributeInputSubmit(
    customAttributeValue: CustomAttributeValue,
    index: number,
  ): void {
    const customAttribute = this.customAttributeFilters[index];
    const newAttributeQueryParams = {};
    switch (customAttribute.type) {
      case CustomAttributeType.BOOLEAN:
        // For CustomAttributeType boolean we only want true values to be stored in the url
        newAttributeQueryParams[customAttribute.id] = customAttributeValue
          ? customAttributeValue
          : null;
        break;
      default:
        newAttributeQueryParams[customAttribute.id] =
          customAttributeValue === '' ? null : customAttributeValue;
        break;
    }

    // Update url without refreshing the page
    this._filter.updateRouterQueryParams({ ...newAttributeQueryParams });
  }

  private _setupFilterResetTracking(): void {
    this._spotlightProfileActions$.pipe(untilDestroyed(this)).subscribe((action) => {
      switch (action) {
        case SpotlightProfilesStateAction.FILTERS_RESET:
          this.customAttributeFilters = clearAllCustomAttributeValues(this.customAttributeFilters);
          this._cdr.detectChanges();
          break;
      }
    });
  }
}

const clearAllCustomAttributeValues = (customAttributes: CustomAttribute[]): CustomAttribute[] => {
  return customAttributes.reduce((newCustomAttributes, customAttribute) => {
    const newCustomAttribute = { ...customAttribute, value: null };
    newCustomAttributes.push(newCustomAttribute);
    return newCustomAttributes;
  }, []);
};
